/* eslint-disable prefer-const */
/* eslint-disable camelcase */

const request = async (url, method, body) => fetch(url, {
  method,
  body,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
});

/**
 * Вспомогательная функция включает функционал
 * показа/скрытия длинного списка чекбоксов-брендов
 * в фильтре каталога товаров.
 */
function toggleHideBrandsCheckbox() {
  const wrapper = document.querySelector('.js-hidden-brands');
  if (!wrapper) return;
  const labels = wrapper.querySelectorAll('.filter__check');
  const moreLink = wrapper.querySelector('.filter__more');
  const maxLabels = wrapper.dataset.maxbrands ? parseInt(wrapper.dataset.maxbrands, 10) : 10;
  let isLinkVisible = false;
  labels.forEach((elem, index) => {
    elem.classList.remove('is-hidden');
    const isInputChecked = elem.querySelector('input:checked');
    if (index >= maxLabels && !isInputChecked) {
      elem.classList.add('is-hidden');
      if (!isLinkVisible) {
        moreLink.classList.add('is-visible');
        isLinkVisible = true;
      }
    }
  });
  function openAllLabels() {
    labels.forEach((elem) => {
      elem.classList.remove('is-hidden');
      moreLink.classList.add('is-opened');
    });
  }
  function closeAllLabels() {
    labels.forEach((elem, index) => {
      const isInputChecked = elem.querySelector('input:checked');
      elem.classList.remove('is-hidden');
      if (index >= maxLabels && !isInputChecked) {
        elem.classList.add('is-hidden');
        if (!isLinkVisible) {
          moreLink.classList.add('is-visible');
        }
      }
      moreLink.classList.remove('is-opened');
    });
  }
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.filter__more');
    if (!link) return;
    e.preventDefault();
    if (link.classList.contains('is-opened')) {
      closeAllLabels();
      return;
    }
    openAllLabels();
  });
}

export default () => {
  const wrapperOld = document.querySelector('.js-filter');
  if (!wrapperOld) return;
  wrapperOld.replaceWith(wrapperOld.cloneNode(true));
  toggleHideBrandsCheckbox();

  const wrapper = document.querySelector('.js-filter');
  if (!wrapper) return;

  const bar = wrapper.querySelector('.js-filter-bar');
  const barValue = bar.querySelector('.js-filter-bar-value');
  const buttons = wrapper.querySelectorAll('[type="submit"]');

  let formUrl = wrapper.getAttribute('action');
  let changeDelay;
  let hideBarDelay;

  const onSubmitForm = (event) => {
    event.preventDefault();

    formUrl = formUrl.replace('/filter/clear/apply/', '/');
    formUrl = formUrl.replace(/\+/g, '%20');

    let $_get = {};
    let formUrlGetParams = '';
    let hasGetParams;

    formUrl.replace(
      /[?&]+([^=&]+)=?([^&]*)?/gi,
      (m, key, value) => {
        $_get[key] = value !== undefined ? value : '';
      },
    );

    hasGetParams = Object.keys($_get).length > 0;
    $_get = {};
    window.location.href.replace(window.location.hash, '').replace(
      /[?&]+([^=&]+)=?([^&]*)?/gi,
      (m, key, value) => {
        $_get[key] = value !== undefined ? value : '';
      },
    );

    if ($_get.sort) {
      formUrlGetParams += `sort=${$_get.sort}`;
    }

    if ($_get['per-page']) {
      formUrlGetParams += `${formUrlGetParams.length > 0 ? '&' : ''}per-page=${$_get['per-page']}`;
    }

    if (formUrlGetParams.length > 0) {
      if (hasGetParams) {
        formUrl += `&${formUrlGetParams}`;
      } else {
        formUrl += `?${formUrlGetParams}`;
      }
    }
    document.location.href = formUrl;
  };

  const autoHideBar = () => {
    clearTimeout(hideBarDelay);

    hideBarDelay = setTimeout(() => {
      bar.classList.remove('active');
    }, 10000);
  };

  const showBar = (input) => {
    bar.classList.add('active');
    bar.style.top = `${input.offsetTop - bar.offsetHeight / 4}px`;
  };

  const barUpdate = (responseObj) => {
    Array.from(buttons).forEach((button) => button.removeAttribute('disabled'));
    barValue.innerText = responseObj.ELEMENT_COUNT || 0;
  };

  const disableInputs = (responseObj) => {
    if (!responseObj.ITEMS) return;

    Object.values(responseObj.ITEMS).forEach((item) => {
      Object.values(item.VALUES).forEach((value) => {
        const input = wrapper.querySelector(`[name="${value.CONTROL_NAME}"]`);
        if (input) {
          if (value.DISABLED) {
            input.setAttribute('disabled', 'disabled');
          } else {
            input.removeAttribute('disabled');
          }
        }
      });
    });
  };

  const formUpdate = (response) => {
    barUpdate(response);
    disableInputs(response);
    formUrl = response.JS_FILTER_PARAMS.SEF_SET_FILTER_URL || formUrl;
    bar.classList.remove('loading');
  };

  const getFilterResults = async () => {
    const formAction = wrapper.getAttribute('action')
      .replace(/smart-filter-accessory=N/, '')
      .replace(/smart-filter-stock=Y/, '')
      .replace('?&', '?');

    wrapper.setAttribute('action', formAction);

    Array.from(wrapper.querySelectorAll('input[disabled]')).forEach((item) => {
      item.removeAttribute('disabled');
    });

    const queryString = `${new URLSearchParams(new FormData(wrapper)).toString()}&ajax=y`;
    const url = `${wrapper.getAttribute('action')}?${queryString}`;

    Array.from(wrapper.querySelectorAll('input[disabled]')).forEach((item) => {
      item.setAttribute('disabled', 'disabled');
    });

    const response = await request(url, 'GET');
    const result = await response.json();
    return result;
  };

  const handleChange = (event) => {
    const input = event.target;

    bar.classList.add('loading');
    Array.from(buttons).forEach((button) => button.setAttribute('disabled', 'disabled'));

    clearTimeout(changeDelay);

    changeDelay = setTimeout(() => {
      showBar(input);

      getFilterResults()
        .then(formUpdate)
        .then(autoHideBar);
    }, 200);
  };
  wrapper.addEventListener('change', handleChange);
  wrapper.addEventListener('rangesliderchange', handleChange);
  wrapper.addEventListener('submit', onSubmitForm);
};
